import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { articleBezpieczenstwo } from '@/mocks/articles';

export default function ArticleBezpieczenstwo() {
  return <ArticleTemplate data={articleBezpieczenstwo} />;
}